// auth
export const LOGOUT = 'LOGOUT'
export const AUTH_DATA = 'AUTH_DATA'
export const AUTH_INITIALIZED = 'AUTH_INITIALIZED'

// apps
export const RECEIVE_APPS = 'RECEIVE_APPS'
export const UPDATE_CUSTOM_STYLE = 'UPDATE_CUSTOM_STYLE'

// plans
export const RECEIVE_PLANS = 'RECEIVE_PLANS'
export const UPDATE_PLAN = 'UPDATE_PLAN'
export const REMOVE_PLAN = 'REMOVE_PLAN'

// references
export const RECEIVE_REFERENCES = 'RECEIVE_REFERENCES'

// user
export const RECEIVE_USER = 'RECEIVE_USER'

// scene navigation
export const CHANGE_LOCATION = 'CHANGE_LOCATION'

// IA editing
export const SET_CUSTOM_FIELD = 'SET_CUSTOM_FIELD'

// GUI
export const CHANGE_EDITOR_POPOVER_VISIBILITY = 'CHANGE_EDITOR_POPOVER_VISIBILITY'

// integrationProducts
export const SET_INTEGRATION_PRODUCTS = 'SET_INTEGRATION_PRODUCTS'

// Last app
export const SET_LAST_APP = 'SET_LAST_APP'

// SHOPIFY APP DATA
export const RECEIVE_SHOPIFY_ASSETS = 'RECEIVE_SHOPIFY_ASSETS'
export const RECEIVE_SHOPIFY_AUTH = 'RECEIVE_SHOPIFY_AUTH'
export const RECEIVE_SHOPIFY_COLLECTION_PRODUCTS = 'RECEIVE_SHOPIFY_COLLECTION_PRODUCTS'

// SHOPIFY Analytics
export const RECEIVE_ORDERS_DATA = 'RECEIVE_ORDERS_DATA'
export const SET_ANALYTICS_DATES_RANGE = 'SET_ANALYTICS_DATES_RANGE'

export const RECEIVE_SHOPIFY_PLANS = 'RECEIVE_SHOPIFY_PLANS'



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js